import 'selectize';

import '../select-plugins/clear_selection';

export function watchVehicleSelectizeTyping(index, type) {
  const selectize = $(
    `#reservation_container_reservation_container_trips_attributes_${index}_schedule_attributes_${type}_id`
  );
  selectize[0].selectize.off('type');
  selectize[0].selectize.on('type', (value) => {
    const service_provider_id = $(
      `#reservation_container_reservation_container_trips_attributes_${index}_schedule_attributes_service_provider_id`
    ).val();
    const pricing_id = $(
      `#reservation_container_reservation_container_trips_attributes_${index}_schedule_attributes_financial_service_provider_id`
    ).val();
    if (value.length > 2) {
      $.getJSON(
        `/vehicles.json?type=${type}&plate=${value}&service_provider_id=${service_provider_id}&pricing_id=${pricing_id}`,
        (res) => {
          selectize[0].selectize.clearOptions();
          if (service_provider_id === '') {
            $.each(res, (_i, el) => {
              selectize[0].selectize.addOption({
                value: el.id,
                text: el.plate,
              });
            });
          } else {
            selectize[0].selectize.addOption(res);
          }
          selectize[0].selectize.refreshOptions();
        }
      );
    }
  });
}

export function vehicleSelectize(type, placeholder) {
  $(`select.selectize-${type}`).each((_i, elem) => {
    const $elem = $(elem);
    if (!$elem[0].selectize) {
      $elem.selectize({
        placeholder,
        selectOnTab: true,
        valueField: 'id',
        labelField: 'plate',
        searchField: ['plate'],
        plugins: {
          clear_selection: {},
        },
      });
    }
  });
}
